import { WalletBase } from '@/utils/wallet/WalletBase';
import { ISignResult } from '@/utils/wallet/types';

export class OkxBTCWallet extends WalletBase {
  authType = 'okx';
  protocolTag = 'okx';
  init(): void {
    if (typeof window.okxwallet !== 'undefined') {
      const provider = window.okxwallet;
      this.provider = provider;
    } else {
      window.open('https://www.okx.com/cn/web3', `_blank`);
    }
  }
  async connect(): Promise<boolean> {
    if (!this.provider) return false;
    const result = await this.provider.bitcoin.connect();
    this.address = result.address;
    this.publicKey = result.compressedPublicKey;
    return true;
  }

  async sign(message: string): Promise<ISignResult> {
    const signature = await this.provider.bitcoin.signMessage(message, {
      from: this.address
    });

    return {
      message,
      signature
    };
  }
}
